"use strict";
const filterMenuSelector = '.js-table_column_dropdown_menu__filter';
const filterMenuSubmitSelector = '.js-table_column_dropdown_menu__filter input[type="submit"]';
window.up.compiler(filterMenuSelector, function (filterMenu) {
    const submitButton = filterMenu.querySelector(filterMenuSubmitSelector);
    const checkboxesNodes = filterMenu.querySelectorAll('input[type=checkbox]');
    const checkboxes = Array.from(checkboxesNodes);
    const showAllCheckbox = checkboxes.find(checkbox => checkbox.value === 'all');
    const itemCheckboxes = checkboxes.filter(checkbox => checkbox.value !== 'all');
    if (showAllCheckbox && submitButton) {
        window.up.on(showAllCheckbox, 'click', undefined, () => {
            const checked = showAllCheckbox.checked;
            itemCheckboxes.forEach(ch => (ch.checked = checked));
            submitButton.disabled = !checked;
        });
        itemCheckboxes.forEach(checkbox => {
            window.up.on(checkbox, 'click', undefined, () => {
                const allChecked = itemCheckboxes.every(ch => ch.checked);
                showAllCheckbox.checked = allChecked;
                const someChecked = itemCheckboxes.some(ch => ch.checked);
                submitButton.disabled = !someChecked;
            });
        });
    }
});
